module.exports = __webpack_public_path__ + "media/images/sp/top/record_deco-af27164444eb33f273cf8f4d035f91d9.svg";